"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import "./Amenities.css";
// import Walkthrough from "../Walkthrough/Walkthrough";

function Amenities({
  amenities_title,
  amenities_tagline,
  amenities_data = [],
  image,
  url,
  specifications,
  otherImage,
}) {
  const [isOpenAmenities, setIsOpenAmenities] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpenAmenities ? "hidden" : "visible";
    return () => (document.body.style.overflow = "visible");
  }, [isOpenAmenities]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") setIsOpenAmenities(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <section className="fifth-section section-padding pt0">
      <div className="fifth-container main-container horizontal relative">
        {/* ⭐ IMAGE ANIMATION (viewport fixed) */}
        <motion.div
          className="fifth-right-content"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7 }}
        >
          <div className="sec5-main-img">
            <motion.img
              src={`${image ? image : otherImage}&h=550&w=500&q=100`}
              alt=""
              id="sec5-main-img"
              initial={{ opacity: 0, scale: 1 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8 }}
            />

            <div className="visible-mobile-only">
              <button
                className="reecosys-template-button view-all-amenities-button button-style-border"
                onClick={() => setIsOpenAmenities(true)}
              >
                <span className="material-symbols-outlined">
                  <img
                    className="view-all-amenities"
                    src="/images/icon/view-all-amenities.svg"
                    alt=""
                  />
                </span>
                <p>View All Amenities</p>
              </button>
            </div>
          </div>

          {/* ⭐ TITLE + TEXT (viewport fix added) */}
          <motion.div
            className="fifth-right-inner-flex horizontal column"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }} // ⭐ important
            transition={{ duration: 0.7 }}
          >
            <div className="fifth-inner-flex-amenities vertical">
              <h4 className="sfpro-bold fifth-title">{amenities_title}</h4>
              <p className="sfpro-medium fifth-subtitle">
                {amenities_tagline ||
                  "Enjoy spaces reserved for the privileged few from guest suites that reflect your standards."}
              </p>

              <div className="hide-mobile-only">
                <button
                  className="reecosys-template-button view-all-amenities-button button-style-border"
                  onClick={() => setIsOpenAmenities(true)}
                >
                  <span className="material-symbols-outlined">
                    <img
                      className="view-all-amenities"
                      src="/images/icon/view-all-amenities.svg"
                      alt=""
                    />
                  </span>
                  <p>View All Amenities</p>
                </button>
              </div>
            </div>

            {/* ⭐ EACH AMENITY BOX (flip animation fixed) */}
            <div className="fifth-inner-flex-right-content">
              {amenities_data.slice(0, 6).map((item, index) => (
                <motion.div
                  className="fifth-amenities-box"
                  key={item.amenity_id}
                  initial={{ rotateY: 90, opacity: 0 }}
                  whileInView={{ rotateY: 0, opacity: 1 }}
                  viewport={{ once: true, amount: 0.3 }} // ⭐ added
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <div className="aminity-icon">
                    <img src={item.icon} alt={item.amenity} />
                  </div>
                  <div className="aminity-text">
                    <p>{item.amenity}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Overlay */}
      <div
        className={`amenity-modal-overlay ${isOpenAmenities ? "active" : ""}`}
        onClick={() => setIsOpenAmenities(false)}
      />

      {/* ⭐ MODAL ANIMATION (unchanged) */}
      <div className={`amenity-modal ${isOpenAmenities ? "active" : ""}`}>
        <div className="modal-header">
          <h3>{amenities_title}</h3>
          <button
            className="close-btn"
            onClick={() => setIsOpenAmenities(false)}
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <div className="modal-content">
          {amenities_data.map((item, index) => (
            <motion.div
              className="modal-amenity-box"
              key={item.amenity_id}
              initial={{ opacity: 0, y: 20 }}
              animate={isOpenAmenities ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: index * 0.05 }}
            >
              <img src={item.icon} alt={item.amenity} />
              <p>{item.amenity}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Amenities;
